import { Pipe, PipeTransform } from "@angular/core";
import { EbsWebService } from "../services/ebsWebService";
import { EbsWebServiceGlobals } from "../services/ebsWebServiceGlobals";

@Pipe({ name: "loadImageFromStorage" })
export class LoadImageFromStorage implements PipeTransform {
  constructor(private _ebsWebService: EbsWebService,
    private _ebsWebServiceGlobals: EbsWebServiceGlobals) {
  }
  transform(value: string) {

    if (value == null) {
      return false;
    }
    if (this._ebsWebServiceGlobals.getLoadIconsFromStorage() == true) {
      //console.log('load icons from storage');
      let base64Image = this._ebsWebService.getIconFromStorage(value);
      return new Promise((resolve) => { resolve(base64Image); });
    } else {
      //console.log('load icon from url', value);
      return new Promise((resolve) => {
        if (value.startsWith('data:image/')) {
          resolve(value);
        } else {
          resolve('./Icons/' + value);
        }
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/pipes/loadImageFromStorage.ts